import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function FinalCTA() {
  return <section className="w-full bg-black py-20 px-4" data-id="element-145">
      <div className="max-w-4xl mx-auto text-center" data-id="element-146">
        {/* Logo */}
        <div className="text-[#FFD700] text-3xl font-black tracking-widest mb-8" data-id="element-147">
          🥁 PROFEPACK™
        </div>

        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-3" data-id="element-148">
          El próximo domingo podés seguir buscando ejercicios en YouTube.
        </h2>
        <p className="text-[#FFD700] text-2xl sm:text-3xl font-black mb-10" data-id="element-149">
          O podés tener todo resuelto desde hoy.
        </p>

        {/* Cost Table */}
        <div className="bg-[#1a1400] border border-[#FFD700]/30 rounded-2xl overflow-hidden mb-12 max-w-2xl mx-auto text-left" data-id="element-150">
          <div className="p-4 bg-[#0d0a00] border-b border-[#FFD700]/30 text-center font-bold text-white" data-id="element-151">
            ¿Cuánto cuesta realmente NO tenerlo?
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-152">
            <div className="p-4 text-gray-400 text-sm" data-id="element-153">
              3 horas de planificación por semana × 40 semanas
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#FFD700]/5 sm:border-l border-gray-800" data-id="element-154">
              120 horas de tu vida por año
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-155">
            <div className="p-4 text-gray-400 text-sm" data-id="element-156">
              Clases sin sistema de evaluación × todos tus alumnos
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#FFD700]/5 sm:border-l border-gray-800" data-id="element-157">
              Alumnos que no ven progreso y se van
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-158">
            <div className="p-4 text-gray-400 text-sm" data-id="element-159">
              Material improvisado que no tiene progresión
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#FFD700]/5 sm:border-l border-gray-800" data-id="element-160">
              Alumnos que se aburren y desertan
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-161">
            <div className="p-4 text-gray-400 text-sm" data-id="element-162">
              Sin sistema de precios ni paquetes
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#FFD700]/5 sm:border-l border-gray-800" data-id="element-163">
              Ingresos 35% por debajo de lo que merecés
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-164">
            <div className="p-4 text-gray-400 text-sm" data-id="element-165">
              Sin banco de mensajes ni seguimiento
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#FFD700]/5 sm:border-l border-gray-800" data-id="element-166">
              Faltas constantes que te hacen perder dinero
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2" data-id="element-167">
            <div className="p-4 text-gray-400 text-sm" data-id="element-168">
              Clases improvisadas que no enganchan
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#FFD700]/5 sm:border-l border-gray-800" data-id="element-169">
              Alumnos que no te recomiendan
            </div>
          </div>
        </div>

        {/* Countdown */}
        <div className="mb-4" data-id="element-170">
          <p className="text-white font-bold mb-4" data-id="element-171">
            ⏰ El precio de lanzamiento cierra en:
          </p>
          <CountdownTimer size="lg" blinking={true} data-id="element-172" />
        </div>
        <p className="text-gray-300 text-sm mb-12" data-id="element-173">
          Después sube{' '}
          <span className="text-[#FF0000] font-bold" data-id="element-174">$8.000 ARS</span> y no
          vuelve.
        </p>

        {/* 2 mini pricing cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-10 max-w-2xl mx-auto" data-id="element-175">
          <div className="bg-[#0a0a0a] border border-[#FFD700]/30 rounded-xl p-6 text-center flex flex-col" data-id="element-176">
            <div className="text-2xl mb-2" data-id="element-177">📘</div>
            <h3 className="text-white font-black mb-1" data-id="element-178">
              MEGAPACK BATERÍA LISTA
            </h3>
            <p className="text-gray-400 text-xs mb-4" data-id="element-179">6 Tomos + 6 Bonos</p>
            <div className="mt-auto" data-id="element-180">
              <p className="text-[#FFD700] text-2xl font-black mb-4" data-id="element-181">
                $19.990 ARS
              </p>
              <a href="https://www.profepack.com/cart/48136091304192:1" className="btn-green-pulse block bg-[#FFD700] text-black font-black py-4 rounded-lg hover:bg-[#FFE44D] transition-colors text-sm" data-id="element-182">
                → QUIERO MI MEGAPACK
              </a>
            </div>
          </div>

          <div className="bg-[#0d0a00] border-2 border-[#FFD700] rounded-xl p-6 text-center shadow-[0_0_30px_rgba(255,215,0,0.2)] flex flex-col" data-id="element-183">
            <div className="text-2xl mb-2" data-id="element-184">🏆</div>
            <h3 className="text-[#FFD700] font-black mb-1" data-id="element-185">
              MEGAPACK + ARSENAL VISUAL ⭐
            </h3>
            <p className="text-gray-400 text-xs mb-4" data-id="element-186">
              6 Tomos + 6 Bonos + Arsenal Visual Premium™
            </p>
            <div className="mt-auto" data-id="element-187">
              <p className="text-[#FFD700] text-3xl font-black mb-4" data-id="element-188">
                $27.990 ARS
              </p>
              <a href="https://www.profepack.com/cart/48136110702848:1" className="btn-green-pulse block bg-[#FFD700] text-black font-black py-4 rounded-lg hover:bg-[#FFE44D] transition-colors text-sm" data-id="element-189">
                → QUIERO EL MEGAPACK + ARSENAL VISUAL
              </a>
            </div>
          </div>
        </div>

        {/* Final trust bar */}
        <div className="flex flex-wrap items-center justify-center gap-3 text-sm text-gray-300" data-id="element-190">
          <span data-id="element-191">🔒 Pago 100% seguro</span>
          <span data-id="element-192">⚡ Acceso en 5 minutos</span>
          <span data-id="element-193">🛡️ Garantía 7 días sin preguntas</span>
          <span data-id="element-194">
            💳 Mercado Pago | Tarjeta de crédito | Transferencia bancaria
          </span>
        </div>
      </div>
    </section>;
}